// extracted by mini-css-extract-plugin
export default {"select-container":"CustomSelect_select-container__QsGpa"};